import { createAppUseApiHook } from '@hwm/ui-lib';
import { httpClient } from './httpClient';

export const useApi = createAppUseApiHook(httpClient);
